export async function extractSvgPath(file) {
  try {
    const text = await file.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "image/svg+xml");
    const paths = doc.querySelectorAll("path");
    return Array.from(paths)
      .map((el) => el.getAttribute("d"))
      .join(" ");
  } catch (err) {
    console.error("Failed to extract SVG path:", err);
    return "";
  }
}
